import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SCHEDULES_FEATURE_KEY,
  State,
  scheduleAdapter
} from './schedules.reducer';

export const selectState = createFeatureSelector<State>(
  SCHEDULES_FEATURE_KEY
);

const { selectAll, selectEntities } = scheduleAdapter.getSelectors();

export const selectLoading = createSelector(
  selectState,
  (state: State) => state.loading
);

export const selectError = createSelector(
  selectState,
  (state: State) => state.error
);
export const selectUpdatedAt = createSelector(
  selectState,
  (state: State) => state.updatedAt
);

export const selectSchedules = createSelector(selectState, (state: State) =>
  selectAll(state)
);
export const selectDrawer = createSelector(
  selectState,
  (state: State) => state.drawer
);

export const selectSchedulesEntities = createSelector(
  selectState,
  (state: State) => selectEntities(state)
);
export const selectActiveSchedule = createSelector(
  selectState,
  (state: State) => state.entities[state.activeScheduleId]
);
